<template>
  <div class="pdl">
    <el-table border header-cell-class-name="tableHeader" :data="list">
      <el-table-column label="商品编码" prop="productCode"></el-table-column>
      <el-table-column label="商品名称" prop="productName"></el-table-column>
      <el-table-column label="产品系列编码" prop="productLevelCode"></el-table-column>
      <el-table-column label="产品系列名称" prop="productLevelName"></el-table-column>
      <el-table-column label="数量（盒/瓶）" prop="num"></el-table-column>
      <el-table-column label="产品单价（元）" prop="productPrice"></el-table-column>
      <el-table-column label="产品总价（元）" prop="productTotalPrice"></el-table-column>
      <el-table-column label="需货申请行号" prop="crmsoLine"></el-table-column>
    </el-table>
  </div>
</template>
<script>
import request from '@/found/utils/request';

export default {
  props: {
    value: [Array, Object],
    disabled: Boolean,
    fApi: Object,
    getRule: Function,
    setValue: Function,
  },
  components: {

  },
  data() {
    return {
      list: [],
    };
  },
  watch: {
    value: {
      deep: true,
      handler(value) {
        console.log('// 标记为已执行');
        console.log(value);
        if (value) {
          console.log(value);
          this.list = value;
        }
      },
    },
  },
  mounted() {

  },
  methods: {

  },
};
</script>
  <style lang="less" scoped>
  .pdl {
    //padding-left: 125px;
  }

  /deep/ .tableHeader {
    background-color: #e8e8e8 !important;
  }

  /deep/ .el-tag {
    margin: 4px;
  }

  .mb10 {
    margin-bottom: 10px;
  }

  .delIcon {
    color: #e16063;
    cursor: pointer;
  }

  .addProIcon {
    color: #169bd5;
    cursor: pointer;
    margin: 4px;
  }

  .avatarUploader {
    .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .el-upload:hover {
      border-color: #409eff;
    }

    .avatar {
      width: 100px;
      height: 100px;
      display: block;
    }

    .avatarUploaderIcon {
      font-size: 28px;
      color: #8c939d;
      width: 100px;
      height: 100px;
      line-height: 100px;
      text-align: center;
    }
  }

  .cusEtag {
    white-space: break-spaces;
    word-break: break-all;
    height: auto;
    position: relative;
    padding-right: 14px;

    /deep/ .el-icon-close {
      position: absolute;
      right: 1px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .tD {
    width: 100%;
    margin-top:20px;

    .tD_area {
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      .tD_right {
        margin-left: 20px;
        font-size: 14px;
        color: #606266;
        display: flex;
        align-items: center;
      }

      .tD_left {
        font-size: 14px;
        color: #606266;
        width:275px;
        span{
          color:#de4e52;
           font-size: 14px;
        }
      }

    }
  }
  </style>
